const FIELD_SELECTOR = "[data-field-key]";

/** First field in page order (marked with `data-field-key`) that has a validation error */
export const getFirstErrorField = (
  container: HTMLElement | null,
  errors: Record<string, unknown>
): HTMLElement | undefined =>
  Array.from(
    container?.querySelectorAll<HTMLElement>(FIELD_SELECTOR) ?? []
  ).find(({ dataset }) =>
    Boolean(dataset.fieldKey && errors[dataset.fieldKey])
  );
